<template>
  <div v-loading="listLoading">
    <div class="lke-titl">
      <div>
        <i class="el-icon-caret-right"></i>
        当前位置：证书详情
      </div>
    </div>
    <div class="lke-mid">
      <div class="lke-mid-top">
        <i class="el-icon-s-order"></i>
        证书详情
      </div>
      <div class="lke-mid-fot">
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            当您的课程学习完毕并通过后可申请相应的证书
          </div>
        </div>
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            如果您有问题可以登录后在学员工作室中提问。会有相应的老师和学员回答您的问题。
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="证书详情" name="0">
        <div v-if="isBy">
          <!-- <canvas id="canvaxbox" width="720" height="570"></canvas> -->
          <img class="lke-img" :src="url + '' + info.certificateImg" alt="">
          <div class="lke-button">
            <el-button
              type="primary"
              size="nimi"
              icon="el-icon-download"
              @click="download()"
              >下载证书</el-button
            >
          </div>
        </div>
        <div v-else>
          <div class="lke-title-fot">
            <div class="lke-title-1">
              {{ userinfo.name }}
            </div>
            尚未完成所有课程，请完成所有课程后再试
            <i class="el-icon-error" style="color: red"></i>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getnew_certificatOne } from "@/api/index";
import { getImgUrl } from "@/utils/auth";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      url: getImgUrl(),
      id: "",
      isBy: true,
      activeName: "0",
      userinfo: {},
      courselist: [],
      certificateCode: "",
      info: {},
      list: [],
      listLoading: false,
    };
  },
  computed: {},
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getlist(this.id);
  },
  watch: {},
  methods: {
    getString(str, n) {
      let strArr = [];
      for (let i = 0, l = str.length; i < l / n; i++) {
        let a = str.slice(n * i, n * (i + 1));
        if (str.length > n * (i + 1) && str.charAt(n * (i + 1) + 1) === " ") {
          a = a + "-";
        }
        strArr.push(a);
      }
      return strArr;
    },
    getlist(val) {
      this.listLoading = true;
      getnew_certificatOne(val).then((response) => {
        this.userinfo = response.userInfo;
        this.info = response
        this.certificateCode = response.certificateCode;
        this.courselist = response.score;
        this.certificateCode = response.certificateCode;
        // this.getcanvas();
        this.listLoading = false;
      });
    },
    getcanvas() {
      let _this = this;
      let c = document.getElementById("canvaxbox");
      let canvas = c.getContext("2d");
      let img = new Image();
      img.crossOrigin = "anonymous";
      // img.src = this.url + this.info.file;
      img.src = require("@/pages/index/assets/zhengshu.jpeg");
      img.onload = imgfn; //图片加载完在执行
      function imgfn() {
        canvas.drawImage(img, 0, 0, c.width, c.height);
        let bg = canvas.createPattern(c, "no-repeat");
        // let bg = canvas.createPattern(img, "no-repeat"); //createPattern() 方法在指定的方向内重复指定的元素。
        canvas.fillStyle = bg; //fillStyle 属性设置或返回用于填充绘画的颜色、渐变或模式。
        canvas.fillRect(0, 0, c.width, c.height); //绘制已填充矩形fillRect(左上角x坐标, 左上角y坐标, 宽, 高)
        canvas.font = "normal normal normal 10px arial";
        canvas.fillStyle = "#60635F";
        canvas.textAlign = "center";
        canvas.textBaseline = "bottom";
        canvas.fillStyle = "#333";
        canvas.fillText(_this.userinfo.name, 590, 194);
        canvas.fillText(_this.userinfo.uid, 590, 227);
        canvas.fillText(_this.certificateCode, 590, 260);
        canvas.fillText(moment(_this.info.createdAt).format("GGGG"), 565, 494);
        canvas.fillText(moment(_this.info.createdAt).format("MM"), 595, 494);
        canvas.fillText(moment(_this.info.createdAt).format("DD"), 620, 494);
        for (let index = 0; index < _this.courselist.length; index++) {
          canvas.fillText(
            _this.courselist[index].courseName,
            454,
            296 + 13.2 * index
          );
          canvas.fillText(
            _this.courselist[index].score,
            548,
            296 + 13.2 * index
          );
        }
        let info = _this.getString(_this.info.info, 25);
        for (let index = 0; index < info.length; index++) {
          canvas.fillText(info[index], 529, 380 + 20 * index);
        }
        canvas.font = "normal normal normal 14px arial";
        canvas.fillText(_this.info.name, 577, 80);
        canvas.fillText(_this.info.subtitle, 577, 100);
        canvas.fillText(_this.info.nameEng, 186, 80);
        canvas.fillText(_this.info.subtitleEng, 186, 100);
        canvas.font = "normal normal normal 12px arial";
        let infoEng = _this.getString(_this.info.infoEng, 48);
        for (let index = 0; index < infoEng.length; index++) {
          canvas.fillText(infoEng[index], 186, 180 + 20 * index);
        }
        let avatar = new Image();
        avatar.crossOrigin = "anonymous";
        // img.src = this.url + this.info.file;
        avatar.src = _this.url + _this.userinfo.sid + ".jpg";
        
        avatar.onload = avatarfn; //图片加载完在执行
        function avatarfn() {
          canvas.drawImage(avatar, 405, 185, 50, 75);
          let bg = canvas.createPattern(c, "no-repeat");
          // let bg = canvas.createPattern(img, "no-repeat"); //createPattern() 方法在指定的方向内重复指定的元素。
          // avatar.fillStyle = bg; //fillStyle 属性设置或返回用于填充绘画的颜色、渐变或模式。
          // avatar.fillRect(0, 0, c.width, c.height); //绘制已填充矩形fillRect(左上角x坐标, 左上角y坐标, 宽, 高)
        }
      }
    },
    download() {
      var a = document.createElement("a");
      let c = document.getElementById("canvaxbox");
      
      // a.href = c.toDataURL();
      a.href = this.url + '' + this.info.certificateImg
      a.download = "证书";
      a.target="view_window"
      // download 属性定义了下载链接的地址
      a.click();
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
::v-deep.el-tabs__item {
  font-size: 18px !important;
  letter-spacing: 1px;
}
::v-deep.el-tabs__item.is-active {
  font-weight: 600;
}
.lke-titl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > div:first-child {
  display: flex;
  align-items: center;
}
.lke-titl i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-mid {
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.lke-mid-top {
  padding: 10px 20px;
  font-size: 18px;
  color: #409eff;
  display: flex;
  align-items: center;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background: #f7f7f7;
}
.lke-mid-top > i {
  font-size: 30px;
  padding-right: 20px;
}
.lke-mid-fot {
  padding: 20px 50px 20px 20px;
  line-height: 2;
}
.lke-tab1in-top > i {
  font-size: 18px;
  color: #409eff;
}
.lke-tab1in-fot {
  display: flex;
  align-items: center;
  padding: 10px 0;
  padding-left: 90px;
}
.lke-tab1in-fot > span {
  font-size: 14px;
  color: #888888;
  padding-right: 50px;
}
.lke-tab1in-fot > div {
  flex: 1;
}
.lke-tab {
  display: flex;
}
.lke-tab-l {
  width: calc(70%);
  color: #666666;
  padding-right: 20px;
  padding-bottom: 30px;
}
.lke-tab-l p {
  font-size: 16px;
  line-height: 2;
  text-indent: 30px !important;
}
.lke-tab-l span {
  line-height: 2;
  font-family: 仿宋_GB2312;
  font-size: 12pt;
  font-weight: bolder;
}
.lke-tab-r {
  text-align: center;
}
.lke-tab-r > img {
  width: 80%;
  padding: 20px 0;
}
.lke-title-1 {
  text-align: center;
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: 600;
  padding-bottom: 15px;
  padding-top: 50px;
}
.lke-title-fot {
  font-size: 18px;
  padding: 50px;
  border: 1px solid #ccc;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
  background: #fffff7;
  margin-bottom: 15px;
  text-align: center;
}
.lke-title-fot > span {
  color: red;
}
.lke-button {
  padding: 20px;
  text-align: center;
}
.lke-img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/zssq/zsxq.vue